import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";

const AdditionalNotesResources = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [additionalNotesResources, setAdditionalNotesResources] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchAdditionalNotesResources = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-AdditionalNotesResources/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setAdditionalNotesResources(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchAdditionalNotesResources();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handleAdditionalNotesResourcesChange = (e) => {
        const { name, value } = e.target;
        setAdditionalNotesResources((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-AdditionalNotesResources/${additionalNotesResources.resource_id}/${brandId}`,
                additionalNotesResources,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchAdditionalNotesResources();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        Additional Notes & Resources
                        <small className="text-danger d-block mt-1" style={{ fontSize: '12px' }}>
                            Last Update: {additionalNotesResources?.updatedAt ? new Date(additionalNotesResources.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>

                    <div className="d-flex align-items-center">
                        <small className="text-warning ">
                            {allowedRoles.includes(role) && (
                                <Button
                                    title="Edit"
                                    icon="pi pi-pencil"
                                    className="p-0 border-0"
                                    text
                                    severity="help"
                                    onClick={handleEditClick}
                                />
                            )}
                        </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Approval Hierarchy for Content & Ads:</th>
                                <td>
                                    {additionalNotesResources?.approval_hierarchy}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Links to Important Docs:</th>
                                <td>
                                    {additionalNotesResources?.important_docs_links}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Additional Guidelines or Notes:</th>
                                <td>
                                    {additionalNotesResources?.additional_guidelines}
                                </td>
                            </tr>

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Edit Brand Overview"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Approval Hierarchy for Content & Ads</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="approval_hierarchy"
                            value={additionalNotesResources.approval_hierarchy}
                            onChange={handleAdditionalNotesResourcesChange}
                            rows={1}
                        />
                    </Col>

                    {/* Links to Important Docs */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>
                            Links to Important Docs <sub>(Drive folders, previous reports, brand assets, etc.)</sub>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            name="important_docs_links"
                            value={additionalNotesResources.important_docs_links}
                            onChange={handleAdditionalNotesResourcesChange}
                            rows={5}
                            className="h-auto"
                        />
                    </Col>

                    {/* Additional Guidelines or Notes */}
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Additional Guidelines or Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="additional_guidelines"
                            value={additionalNotesResources.additional_guidelines}
                            onChange={handleAdditionalNotesResourcesChange}
                            rows={2}
                            className="h-auto"
                        />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};

export default AdditionalNotesResources
